let module = angular.module('one-or-all-dialog', []);
module.service('OneOrAllDialog', function ($uibModal) {
  'ngInject';
  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: `
      <div class="modal-header">
        <h3 class="modal-title">{{modalOptions.headerText}}</h3>
      </div>
      <div class="modal-body">
        <p>{{modalOptions.bodyText}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-{{modalOptions.closeButtonClass}}" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button>
        <button class="btn btn-{{modalOptions.allButtonClass}}" data-ng-click="modalOptions.ok('all');">{{modalOptions.allButtonText}}</button>
        <button class="btn btn-{{modalOptions.oneButtonClass}}" data-ng-click="modalOptions.ok('one');">{{modalOptions.oneButtonText}}</button>
      </div>
    `,
  };
  var modalOptions = {
    headerText: 'Proceed?',
    bodyText: 'Perform this action?',
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    allButtonText: 'All Upcoming Broadcasts In The Series',
    allButtonClass: 'primary',
    oneButtonText: 'This Broadcast Only',
    oneButtonClass: 'primary',
  };
  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {};
    //Map angular-ui modal custom defaults to modal defaults defined in service
    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
    //Map modal.html $scope custom properties to defaults defined in service
    angular.extend(tempModalOptions, modalOptions, customModalOptions);
    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';
        $scope.modalOptions = tempModalOptions;
        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }
    return $uibModal.open(tempModalDefaults).result;
  };
});
export default module;



// WEBPACK FOOTER //
// ./app/services/one-or-all-dialog.js